<template>
<div class ="ml-7">
  <Breadcrumb/>
  <v-row>
      <v-col
      class =""
      cols="4"
      md="4"
    >
      <!--      
      <div class="div0" v-if="main_layer">
        <Map id="mappa1" type="medium" selector="true" 
        :lng="lng" :zoom="zoom" :lat="lat" :start="start" :end="end" :main_layer="main_layer"/>
      </div>
      -->
      <div class="mainmap" v-if="main_layer">
        <Map2 type="medium" selector="true" id="metroreg_m1" 
          start="-18667756.795919 13893194.261114" end="19880965.308861 -10057889.929877"
          :main_layer="main_layer"/>
      </div>

    </v-col>
    <v-col
      class =""
      cols="8"
      md="8"
    >
      <GraphBar type="chart_map"/>
    </v-col>
  </v-row>
</div>
</template>

<script>
import GraphBar from '@/components/GraphBar'
import Breadcrumb from '@/components/Breadcrumb'
import Map2 from '@/components/Map2'
// import Map from '@/components/Map2'

import VectorImageLayer from 'ol/layer/VectorImage'

export default {
  name: 'MetroRegional',
  props: {
  },  
  components: { GraphBar, Map2, Breadcrumb },  
  data () {
    let lat = null
    let lng = null
    let start = null
    let end = null
    let zoom = null
    let main_layer = null
    let TU = ''

    return {
      main_layer, lat, lng, zoom, start, end, TU
    }
    
  },
  methods: {
    },
  watch: {
      '$route' () {
          this.TU = this.$store.getters.TU
      }
      },
  mounted () {
    console.log("**** MetroRegional MOUNTED ****")
    this.TU = this.$store.getters.TU
    this.start="1"
                
    this.main_layer = new VectorImageLayer({
      name: 'polygon',
      imageRatio: 2,
    })
    // this.$root.$emit('manage_layers')
    // this.$root.$emit('initMap')

  }  
}
</script>
